import { Observable } from "rxjs"
import PoolSelection from "./RandomsModel/PoolSelection"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function PoolSelectionListGetObservable(poolId: number, pageNumber: number, pageSize: number, accountId: number = 0): Observable<PoolSelection> {
  const params: string = JSON.stringify({
    PoolID: poolId,
    AccountID: accountId,
    PageNumber: pageNumber,
    PageSize: pageSize
  })

  return ObservableFromFetch<PoolSelection>("RandomTest/GetPoolSelectionList", params)
}
